import SubaruLogo from '@components/bits/icons/SubaruLogo'; /* webpackPreload: true */
// import Debug from '@components/Debug';
import DebugTailwind from '@components/Debug/DebugTailwind';
import Footer from '@components/layout/Footer' /* webpackPreload: true */;
import Header from '@components/layout/Header'; /* webpackPreload: true */
import PrintWrapper from '@components/layout/PrintWrapper';
import Plug from '@components/plugs/Plug';
import * as fbq from '@utils/fpixel';
import { FB_PIXEL_ID } from '@utils/fpixel';
import { GADS, GTM_ID, NEXT_PUBLIC_GA_4_ID, pageview } from '@utils/gtag';
import Details from 'components/plugs/modals/Details';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import Script from 'next/script';
import React, { FunctionComponent, Suspense, useEffect, useState } from 'react';
import { ActionType } from 'reducers/reducer';
import { StateProvider, useStateContext } from 'reducers/state';

// import Debug from '../components/Debug';
import DynamicHead from '../components/DynamicHead';

const DynamicComponentWithNoSSR = dynamic(() => import('@components/layout/Cookies'), {
  ssr: false,
});

type Props = {
  Component;
  pageProps?;
};

const Wrapper: FunctionComponent<Props> = (props) => {
  return (
    <StateProvider>
      <Suspense fallback={<div></div>}>
        <Web {...props} />
      </Suspense>
    </StateProvider>
  );
};

const Web: FunctionComponent<Props> = ({ Component, pageProps }) => {
  const { dispatch } = useStateContext();
  const [cookie, setCookie] = useState(null);
  const router = useRouter();

  useEffect(() => {
    if (cookie) {
      window.localStorage.setItem('cookie', JSON.stringify(cookie));
    }
  }, [cookie]);

  let ogImage = '';
  let description = '';

  if (pageProps && pageProps?.data?.page?.openGraphImage?.asset?.url) {
    ogImage = pageProps?.data?.page?.openGraphImage?.asset?.url;
    description = pageProps?.data?.page?.description;
  } else if (pageProps && pageProps?.model && pageProps?.model?.length) {
    ogImage = pageProps?.model[0]?.content?.carInfo?.figure?.asset?.url || '';
  }

  useEffect(() => {
    const loc = String(document.location);
    const params = new URL(loc).searchParams;
    const type = params.get('type');
    const id = params.get('id');

    if (type && type !== '' && id && id !== '') {
      let campaigns;
      let elements;
      let element;
      let payload;

      if (type === 'campaign') {
        campaigns = pageProps.data.page.content
          .filter((val) => val._type === 'campaigns')
          .map((val) =>
            val.campaigns.forEach((val) => {
              if (val._type === type && val._id === id) {
                element = val;
              }
            })
          );
        elements = pageProps && pageProps.data.page.content.filter((val) => val._type === type);

        if (!element) {
          element =
            elements.find((val) => val._key === id) || campaigns.find((val) => val._key === id);
        }

        payload = {
          data: {
            _key: element._id,
            _type: element._type,
            plugs: element.content.plugs,
          },
        };
      } else {
        elements = pageProps && pageProps.data.page.content.filter((val) => val._type === type);
        element = elements.find((val) => val._key === id);

        payload = {
          data: element,
        };
      }

      if (element) {
        dispatch({ type: ActionType.DATA, payload });
      }
    }
  }, [dispatch]);

  useEffect(() => {
    const handleRouteChange = (url): void => {
      if (typeof window !== 'undefined' && url && process.env.enviroment === 'production') {
        pageview(url);
        fbq.pageview();
      }
    };
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);

  useEffect(() => {
    const printContents = document.getElementById('subaru-container');

    window.addEventListener('beforeprint', () => {
      printContents.classList.add('SC__print');
    });

    window.addEventListener('afterprint', () => {
      printContents.classList.remove('SC__print');
    });

    const lsCoockie = window.localStorage.getItem('cookie');
    if (lsCoockie) {
      setCookie(JSON.parse(lsCoockie));
    } else {
      const newD = {};

      Object.keys(cookies.settings).forEach((val) => {
        const elm: { title: string; preselcted: boolean } = cookies.settings[val];
        newD[elm.title] = elm.preselcted;
      });

      updateCookies(newD);
    }
  }, []);

  const updateCookies = (newCookie): void => {
    const nc = { ...cookie, ...newCookie };
    setCookie(nc);
  };

  if (!pageProps && !pageProps.global) return null;

  const data = pageProps?.data;
  const global = pageProps?.global;
  const { mainNavigation, footer, cookies } = global?.content || {};

  const invertedMenu = data?.page?.invertedMenu;

  return (
    <>
      {/* {process.env.NODE_ENV === 'production' && (
        // <Script
        //   src={`https://www.googletagmanager.com/gtag/js?id=${NEXT_PUBLIC_GA_ID}`}
        //   strategy="afterInteractive"
        // />
      )} */}

      {process.env.NODE_ENV === 'production' && (
        <Script id="google-analytics" strategy="afterInteractive">
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                  })(window,document,'script','dataLayer','${GTM_ID}');`}
        </Script>
      )}

      {process.env.NODE_ENV === 'production' && (
        <Script id="google-dl" strategy="afterInteractive">
          {`window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${NEXT_PUBLIC_GA_4_ID}', {
                page_path: window.location.pathname,
              });
              gtag('config', '${GADS}', {
                page_path: window.location.pathname,
              });
          `}
        </Script>
      )}
      {process.env.NODE_ENV === 'production' && (
        <Script id="google-fp" strategy="afterInteractive">
          {`
                !function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', ${FB_PIXEL_ID});
              `}
        </Script>
      )}
      {process.env.NODE_ENV === 'production' && (
        <noscript>
          <img
            alt=""
            height="1"
            width="1"
            style={{ display: 'none' }}
            src={`https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1`}
          />
        </noscript>
      )}
      {process.env.NODE_ENV === 'production' && (
        <noscript>
          <iframe
            src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
            height="0"
            width="0"
            style={{ display: 'none', visibility: 'hidden' }}></iframe>
        </noscript>
      )}

      <DynamicHead ogImage={ogImage} ogDescription={description}>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </DynamicHead>

      <div className="ie">
        <SubaruLogo color="white" />
        <p>
          Din nettleser er utdatert, du kan åpne nettsiden vår i Microsoft Edge ved å klikke på
          linken: <a href="microsoft-edge:https://www.subaru.no">subaru.no</a>
        </p>
      </div>
      {/* <Debug /> */}
      <DebugTailwind />

      {cookie?.seenCookie ? null : cookie ? (
        <DynamicComponentWithNoSSR cookieData={cookie} updateCookies={updateCookies} {...cookies} />
      ) : null}

      <Details />

      <PrintWrapper>
        <Header mainmenu={mainNavigation} invertedMenu={invertedMenu} />
        <Component {...pageProps} />
        <Plug key={'plug'} {...footer.plug}>
          <Footer {...footer} />
        </Plug>
      </PrintWrapper>
    </>
  );
};

export default Wrapper;
